import Push from 'push.js';
import { store } from '../store';
import { actualizarPushNotificaciones } from '../../apiService/request/Notificaciones';

const { db } = require('../firebaseConfig');
const NotificacionesDB = db.collection("notificaciones");

export default {
  state: {
    notificaciones: [],
  },
  getters: {
    getNotificaciones: state => state.notificaciones,
  },
  mutations: {
    clearNotificaciones(state) {
      state.notificaciones = [];
    },
    addedNotificaciones(state, valor) {
      if (!valor.notificado) {
        Push.create("Neumobot", {
          body: valor.contenido.replace(/(<([^>]+)>)/ig, ""),
          timeout: 4000
        });
        actualizarPushNotificaciones(valor);
      }
      state.notificaciones.push(valor);
    },
    removeNotificaciones(state, valor) {
      state.notificaciones = state.notificaciones.filter(notificacion => notificacion.id !== valor.id);
    },
    modifiedNotificaciones(state, valor) {
      state.notificaciones = state.notificaciones.map(notificacion => {
        if (notificacion.id === valor.id) {
          notificacion = valor;
        }
        return notificacion;
      });
    },
  },
  actions: {
    initNotificaciones({ commit }) {
      commit('clearNotificaciones');
      
      NotificacionesDB
        .where('usuario', '==', store.state.provider_email)
        .where('visto', '==', false)
        .limit(50)
        .onSnapshot((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === 'added') {
              commit('addedNotificaciones', {
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
            if (change.type === 'modified') {
              commit('modifiedNotificaciones', {
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
            if (change.type === 'removed') {
              commit('removeNotificaciones', {
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
          });
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/modules/Notificaciones.js